export const PublicStrings = {
    totalItems: 'Elementi Totali',
    page:'Pagina',
    previous:'Precedente',
    next:'Successivo',
    back:'Indietro',
    add:'Aggiungere',
    save:'Salva',
    changePassword:'Cambia Password'
}